import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4a3 3 0 0 1 3 3v9","key":"svg-0"}],["path",{"d":"M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3","key":"svg-1"}],["path",{"d":"M13 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}]]

const IconZodiacCapricorn = createReactComponent('outline', 'zodiac-capricorn', 'ZodiacCapricorn', __iconNode);

export default IconZodiacCapricorn;